<template>
	<app-page-content>
		<app-title>Correspondencia</app-title>
		<v-expansion-panel>
			<v-expansion-panel-content>
				<div slot="header">Filtros</div>
				<v-card>
					<v-card-title class="headline">Filtros</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout wrap>
								<v-flex xs12>
									<v-select
										:items="mailTypes"
										item-text="name"
										item-value="id"
										label="Tipo de correspondencia"
										v-model="filters.type"
									/>
								</v-flex>
								<v-flex xs12>
									<v-menu
										:close-on-content-click="false"
										v-model="menu"
										:nudge-right="40"
										lazy
										transition="scale-transition"
										offset-y
										full-width
										min-width="290px"
									>
										<v-text-field
											slot="activator"
											v-model="filters.date"
											label="Fecha recibimiento"
											prepend-icon="event"
											readonly
										></v-text-field>
										<v-date-picker
											v-model="filters.date"
											@input="menu = false"
										></v-date-picker>
									</v-menu>
								</v-flex>
								<v-flex xs6>
									<v-btn
										small
										color="primary"
										@click="searchMails"
										>Filtrar</v-btn
									>
								</v-flex>
								<v-flex xs6>
									<v-btn small flat @click="cancelFilter"
										>Restablecer</v-btn
									>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<div v-if="mails">
			<v-list two-lines>
				<template v-for="(mail, index) in mails">
					<v-list-tile :key="mail.name" class="mail-item">
						<v-list-tile-avatar>
							<img src="../../assets/mail.png" alt="" />
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-sub-title
								><strong>Recibido el:</strong>
								{{
									mail.created_at | datetime
								}}</v-list-tile-sub-title
							>
							<v-list-tile-sub-title
								><strong>Estado:</strong>
								{{
									!!mail.delivered
										? 'Entregado'
										: 'Sin Entregar'
								}}</v-list-tile-sub-title
							>
							<v-list-tile-sub-title
								><strong>Notas:</strong>
								{{
									!!mail.notes
										? mail.notes
										: '-- Sin notas --'
								}}</v-list-tile-sub-title
							>
						</v-list-tile-content>

						<v-list-tile-content>
							<v-btn
								slot="activator"
								@click="seeMore(mail)"
								flat
								icon
								color="primary"
								><v-icon>zoom_in</v-icon></v-btn
							>
						</v-list-tile-content>
					</v-list-tile>
					<v-divider :key="index"></v-divider>
				</template>
			</v-list>
			<div class="text-xs-center">
				<v-pagination
					v-if="!!mails"
					v-model="page"
					:length="totalPages"
				></v-pagination>
			</div>
		</div>
		<v-alert v-else :value="!mails" type="info">
			¡Aún no has recibido correspondencia!
		</v-alert>

		<v-layout row justify-center v-if="selectMail">
			<v-dialog
				v-model="dialog"
				fullscreen
				hide-overlay
				transition="dialog-bottom-transition"
			>
				<v-card>
					<v-toolbar dark color="primary">
						<v-btn icon dark @click="closeDialogSeeMore">
							<v-icon>arrow_back</v-icon>
						</v-btn>
						<v-toolbar-title>Información detallada</v-toolbar-title>
					</v-toolbar>
					<v-list three-line subheader>
						<v-subheader>Información</v-subheader>
						<v-list-tile>
							<v-list-tile-content>
								<v-list-tile-sub-title
									><strong>Estado:</strong>
									{{
										!!selectMail.delivered
											? 'Entregado'
											: 'Sin Entregar'
									}}</v-list-tile-sub-title
								>
								<v-list-tile-sub-title
									><strong>Tipo: </strong>
									{{
										selectMail.mail_type.name
									}}</v-list-tile-sub-title
								>
								<v-list-tile-sub-title
									><strong>Recibido el:</strong>
									{{
										selectMail.created_at | datetime
									}}</v-list-tile-sub-title
								>
								<v-list-tile-sub-title
									><strong>Notas:</strong>
									{{
										!!selectMail.notes
											? selectMail.notes
											: '-- Sin notas --'
									}}</v-list-tile-sub-title
								>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
					<v-divider></v-divider>
					<v-list
						three-line
						subheader
						v-if="selectMail.photos.length"
					>
						<v-subheader>Fotos</v-subheader>
						<v-row v-for="(item, i) in selectMail.photos" :key="i">
							<v-flex class="mb-2">
								<v-card class="pa-2">
									<v-img
										class="photo"
										:src="item.photo_url"
									></v-img>
								</v-card>
							</v-flex>
						</v-row>
						<!-- <v-carousel>
							<v-carousel-item
								v-for="(item, i) in selectMail.photos"
								:key="i"
								:src="item.photo_url"
								class="photo"
							></v-carousel-item>
						</v-carousel> -->
					</v-list>
				</v-card>
			</v-dialog>
		</v-layout>
	</app-page-content>
</template>
<script>
import mailRepository from '../../repositories/mail.repository'
export default {
	data() {
		return {
			data: {},
			page: 1,
			filters: {},
			mailTypes: [],
			menu: '',
			dialog: false,
			notifications: false,
			sound: true,
			widgets: false,
			selectMail: ''
		}
	},
	watch: {
		page(val) {
			this.loadMails()
		}
	},
	computed: {
		mails() {
			if (!this.data) return []

			return this.data.data
		},
		totalPages() {
			if (!this.data) return 0

			return Math.ceil(this.data.total / parseInt(this.data.per_page))
		}
	},
	methods: {
		loadMails() {
			const mr = { ...mailRepository }
			mr.getMails(this.person.id, this.filters, this.page)
				.then(resp => (this.data = resp.data))
				.catch(error =>
					alert('Ocurrió un error al cargar la correspondencia')
				)
		},
		searchMails() {
			this.page = 1
			this.loadMails()
		},
		cancelFilter() {
			this.page = 1
			Object.keys(this.filters).map(key => (this.filters[key] = ''))
			this.loadMails()
		},
		loadMailTypes() {
			const mr = { ...mailRepository }
			mr.getMailTypes()
				.then(resp => {
					this.mailTypes = resp.data
				})
				.catch(error => {
					// toastr.error('Error al cargar los tipos de correspondencia', {dismissible: false});
					console.log(error)
				})
		},
		seeMore(mail) {
			this.dialog = true
			this.selectMail = mail
		},
		closeDialogSeeMore() {
			this.dialog = false
			this.selectMail = ''
		},
		initialize() {
			this.loadMails()
			this.loadMailTypes()
		}
	},
	created() {
		this.initialize()
	}
}
</script>
<style>
.mail-item {
	margin: 10px 0;
}
.photo {
	max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Mail/Mail.vue